import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantEmploymentDurationPage = {
  alert: {
    error: 'applicant-employment-duration.form.alert.error',
  },
  footer: {
    root: 'applicant-employment-duration.footer.root',
  },
  form: {
    h1: 'applicant-employment-duration.form.h1',
    h2: 'applicant-employment-duration.form.h2',
    radioGroupRoot: 'applicant-employment-duration.form.radio-group-root',
    radioOption1: 'applicant-employment-duration.form.radio-option1',
    radioOption2: 'applicant-employment-duration.form.radio-option2',
    root: 'applicant-employment-duration.form.root',
    submitButton: 'applicant-employment-duration.form.submit-button',
  },
  header: {
    drawerButton: 'applicant-employment-duration.header.drawer-button',
    previousStepButton:
      'applicant-employment-duration.header.previous-step-button',
    root: 'applicant-employment-duration.header.root',
  },
  progress: {
    root: 'applicant-employment-duration.progress.root',
  },
} as const satisfies PageLocatorMap;
